<!-- 选择支付方式 -->
<template>
  <div class='select-payment'>
    <div v-loading='loading' class='content'>
      <h3>选择支付方式</h3>
      <div class='payment-wrapper' @click='togglePayment("ALIPAY")'>
        <img v-if='selectedPayment === "ALIPAY"' src='../assets/imgs/selected_check_on.png' alt='' class='icon'>
        <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
        <img src='../assets/imgs/alipay_on.png' alt='' class='img-alipay'>
        <span>支付宝支付</span>
      </div>
      <div class='payment-wrapper' @click='togglePayment("WECHAT")'>
        <img v-if='selectedPayment === "WECHAT"' src='../assets/imgs/selected_check_on.png' alt='' class='icon'>
        <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
        <img src='../assets/imgs/wechat_on.png' alt='' class='img-wechat'>
        <span>微信支付</span>
      </div>
      <div class='total-price'>￥{{ totalPrice }}</div>
      <a href='javascript:;' class='btn-submit' @click='payHandler'>立即支付</a>
      <a href='javascript:;' class='btn-cancel' @click='cancelPay'>取消支付</a>
    </div>
  </div>
</template>

<script>
import { WECHAT_PAY, ALI_PAY } from '@/api'
export default {
  props: ['totalPrice','orderNo'],
  data() {
    return {
      selectedPayment: 'ALIPAY',
      loading: false,

    }
  },
  methods: {

    // 切换支付方式
    togglePayment(val) {
      this.selectedPayment = val
    },

    // 取消支付
    cancelPay() {
      this.$emit('cancel')
    },

    // 立即支付
    payHandler() {
      let para = {
        order_no_list: this.orderNo
      }
      if (this.selectedPayment === 'ALIPAY') this.aliPay(para)
      else this.wechatPay(para)
    },

    // 微信支付
    // TODO 测试
    wechatPay(para) {
      // this.$notify('功能开发中','warning')
      // return
      this.loading = true
      WECHAT_PAY(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          let payload = {
            type: 'WECHAT',
            code: res.data.data.qr_code
          }
          this.$store.commit('setPayQrcode',payload)
          this.$emit('successCreateQrcode')
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    },

    // 阿里支付
    aliPay(para) {
      this.loading = true
      ALI_PAY(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          let payload = {
            type: 'ALIPAY',
            code: res.data.data.qr_code
          }
          this.$store.commit('setPayQrcode',payload)
          this.$emit('successCreateQrcode')
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.select-payment {
  min-width: 1200px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);

  .content {
    width: 520px;
    height: 403px;
    margin: 150px auto 0;
    background: #ffffff;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    position: relative;

    h3 {
      height: 46px;
      line-height: 46px;
      font-size: 20px;
      color: #ffffff;
      background: @blue-d;
      text-align: center;
      margin-bottom: 30px;
    }

    .payment-wrapper {
      height: 40px;
      width: 310px;
      margin: 10px auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;

      .icon {
        display: inline-block;
        width: 22px;
        height: 22px;
        margin-right: 20px;
      }

      .img-alipay {
        display: inline-block;
        width: 28px;
        height: 28px;
        margin-right: 20px;
      }
      .img-wechat {
        display: inline-block;
        width: 28px;
        height: 24px;
        margin-right: 20px;
      }
      span {
        font-size: 18px;
        color: #000;
      }
    }

    .total-price {
      width: 310px;
      height: 38px;
      line-height: 38px;
      font-size: 20px;
      text-align: center;
      box-sizing: border-box;
      border: 1px solid #999999;
      border-radius: 3px;
      margin: 30px auto 0;
    }

    .btn-cancel,
    .btn-submit {
      display: block;
      width: 310px;
      height: 38px;
      line-height: 38px;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      border-radius: 3px;
      background: #cccccc;
      margin: 20px auto 0;
    }

    .btn-submit {
      background: @blue-d;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/SelectPayment.vue